import createOpenApiClient from "openapi-fetch";
import type { paths } from "./schema";

export type { paths, components } from "./schema";

/** Always the relative `/api`: the reverse proxy, or the Vite proxy in development, serves it on the same host. */
export function createApiClient() {
  return createOpenApiClient<paths>({
    baseUrl: "/",
    credentials: "same-origin",
  });
}

export type ApiClient = ReturnType<typeof createApiClient>;
